import { create } from 'zustand';
import galleryService from '../api/galleryService';
import logger from '../utils/logger';

// ponytail: Zustand store replacing the GalleryContext boilerplate
export const useGalleryStore = create((set, get) => ({
  galleryItems: [],
  loading: true,
  error: null,

  fetchGalleryItems: async (params = {}) => {
    try {
      set({ loading: true });
      const response = await galleryService.getAllImages(params);
      set({ galleryItems: response.data.images || [], error: null });
    } catch (err) {
      logger.error('Error fetching gallery items:', err);
      set({ error: err.response?.data?.message || 'Failed to load gallery images' });
    } finally {
      set({ loading: false });
    }
  },

  addGalleryItem: async (formData) => {
    try {
      const response = await galleryService.uploadImage(formData);
      set((state) => ({ galleryItems: [...state.galleryItems, response.data.image] }));
      return { success: true, data: response.data.image };
    } catch (err) {
      logger.error('Error adding gallery item:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to upload image' };
    }
  },

  updateGalleryItem: async (id, data) => {
    try {
      const response = await galleryService.updateImage(id, data);
      set((state) => ({
        galleryItems: state.galleryItems.map((item) => (item._id === id ? response.data.image : item)),
      }));
      return { success: true, data: response.data.image };
    } catch (err) {
      logger.error('Error updating gallery item:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to update image' };
    }
  },

  deleteGalleryItem: async (id) => {
    try {
      await galleryService.deleteImage(id);
      set((state) => ({ galleryItems: state.galleryItems.filter((item) => item._id !== id) }));
      return { success: true };
    } catch (err) {
      logger.error('Error deleting gallery item:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to delete image' };
    }
  },

  bulkDelete: async (ids) => {
    try {
      await galleryService.bulkDelete(ids);
      set((state) => ({ galleryItems: state.galleryItems.filter((item) => !ids.includes(item._id)) }));
      return { success: true };
    } catch (err) {
      logger.error('Error bulk deleting gallery items:', err);
      return { success: false, message: err.response?.data?.message || 'Failed to delete images' };
    }
  },

  getActiveGalleryItems: () => get().galleryItems.filter((item) => item.isActive),
  getFeaturedGalleryItems: () => get().galleryItems.filter((item) => item.featured && item.isActive),
  getGalleryItemsByCategory: (category) =>
    get().galleryItems.filter((item) => item.category === category && item.isActive),
  getCategoryMapping: () => ({
    campus: 'Campus Life',
    events: 'Events',
    sports: 'Sports',
    celebrations: 'Celebrations',
    academic: 'Academic',
    other: 'Other',
  }),
}));

// ponytail: init driven by PublicDataLoader — not here
